export type Lang = 'vi' | 'en';

export const LANG_STORAGE_KEY = 'nagiLang';

export type ExtraSectionKey = 'psych' | 'practical' | 'sex' | 'pressure';